var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { ref: "popover", attrs: { width: "400", trigger: "click" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-form",
            { ref: "form", attrs: { size: "mini", "label-width": "70px" } },
            [
              _c("el-form-item", { attrs: { label: "Tips:" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#909399",
                      "font-size": "8px",
                      "margin-left": "3px",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("panel.web_set_tips")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("panel.web_url") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.linkInfoTemp.src,
                      callback: function ($$v) {
                        _vm.$set(_vm.linkInfoTemp, "src", $$v)
                      },
                      expression: "linkInfoTemp.src",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v(_vm._s(_vm.$t("panel.confirm")))]
                  ),
                  _c("el-button", { on: { click: _vm.onClose } }, [
                    _vm._v(_vm._s(_vm.$t("panel.cancel"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("i", {
        staticClass: "icon iconfont icon-chaolianjie",
        attrs: { slot: "reference" },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }